import React,{ useEffect, useState } from 'react';
import {Page } from 'react-weui';
import { Toast } from 'antd-mobile';


import { getCourseLog, getConvertCourseLog,getCollectLog,getBrowseLog } from '@/services/myself';
import { history, useLocation } from 'umi';

import LearningItem from '../../myself/courseList/components/LearningItem';
import BuyItem from '../../myself/courseList/components/BuyItem';
import CollectItem from '../../myself/courseList/components/CollectItem';
import BrowseItem from '../../myself/courseList/components/BrowseItem';

import Empty from '@/components/empty';

export default (props) => {

  const [dataList, setDataList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数


  useEffect(() => {
    switch (props.location.state.type) {
      case 1: {
        document.title = '课程历史';
        getCourseRecord(1);
        break;
      }
      case 2: {
        document.title = '兑换历史';
        getBuyCourse(1);
        break;
      }
    }


  }, []);




  return (
    <Page
      transition={true}
      infiniteLoader={true}
      ptr={false}
      onLoadMore={(resolve, finish) => {
        if (dataList.length >= totalCount && totalCount !== 0) {
          // 用总条数判断
          finish();
          return;
        }
        switch (props.location.state.type) {
          case 1: {
            getCourseRecord(pageNo + 1, resolve, finish);
            return;
          }
          case 2: {
            getBuyCourse(pageNo + 1, resolve, finish);
            return;
          }
        }

        resolve();
      }}
    >
      {dataList.length ? (
        dataList.map(item => (
          <ListItem
            data={item}
            type={props.location.state.type}
            key={item.id}
          />
        ))
      ) : (
        <Empty text={'暂无数据'} />
      )}

      {dataList.length >= totalCount && totalCount !== 0 && (
        <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
          没有更多数据了
        </div>
      )}
    </Page>
  );

  function getCourseRecord(pageNo,resolve, finish) {
    getCourseLog({pageNo:pageNo, pageSize:20}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (pageNo == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(pageNo);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断
      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }

  function getBuyCourse(pageNo,resolve, finish) {
    getConvertCourseLog({pageNo:pageNo, pageSize:20}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (pageNo == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(pageNo);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断
      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }


}




const ListItem  = (props) => {
  const { data, type } = props;
  switch (type) {
    case 1:
      return  <LearningItem data={data}/>
    case 2:
      return <BuyItem data={data}/>

  }

}
